import React from 'react';
import { ChevronRight } from 'lucide-react';
import { getStageConfig, formatValue, formatDate } from '../crmConstants';

export const DealsListView = ({ deals, userRole, onDealClick }) => {
  const headers = ['Contact', 'Company', 'State', 'Stage', 'Value'];
  if (userRole === 'admin') headers.push('Commission');
  headers.push('Assigned', 'Date', '');

  return (
    <div style={{ background: '#fff', borderRadius: 8, border: '1px solid #E5E7EB', overflow: 'hidden' }}>
      <table style={{ width: '100%', borderCollapse: 'collapse' }} data-testid="deals-table">
        <thead>
          <tr style={{ background: '#FAFBFC' }}>
            {headers.map((h, idx) => (
              <th key={h || `col-${idx}`} style={{
                padding: '0.625rem 1rem', fontSize: '0.7rem', fontWeight: 600, color: '#9CA3AF',
                textTransform: 'uppercase', letterSpacing: '0.05em', textAlign: 'left', borderBottom: '1px solid #E5E7EB',
              }}>
                {h}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {deals.length === 0 ? (
            <tr><td colSpan={headers.length} style={{ textAlign: 'center', padding: '2rem', color: '#9CA3AF', fontSize: '0.875rem' }}>No deals found</td></tr>
          ) : deals.map((deal, i) => {
            const sc = getStageConfig(deal.stage || 'New Lead');
            const dealValue = deal.deal_value || deal.annual_savings || 0;
            const commissionPct = deal.company_commission_percent || 10;
            const commissionAmt = dealValue * (commissionPct / 100);
            return (
              <tr
                key={deal.id || `deal-${i}`}
                style={{ cursor: 'pointer', borderBottom: '1px solid #F3F4F6' }}
                onClick={() => onDealClick(deal)}
                data-testid={`deal-row-${i}`}
              >
                <td style={{ padding: '0.625rem 1rem' }}>
                  <div style={{ fontWeight: 500, color: 'var(--navy)', fontSize: '0.875rem' }}>{deal.name || '—'}</div>
                  <div style={{ fontSize: '0.7rem', color: '#9CA3AF' }}>{deal.email || ''}</div>
                </td>
                <td style={{ padding: '0.625rem 0.5rem', fontSize: '0.813rem', color: '#6B7280' }}>
                  {deal.company || deal.business_name || '—'}
                </td>
                <td style={{ padding: '0.625rem 0.5rem', fontSize: '0.813rem', color: '#6B7280' }}>{deal.state || '—'}</td>
                <td style={{ padding: '0.625rem 0.5rem' }}>
                  <span style={{
                    display: 'inline-block', padding: '2px 8px', borderRadius: 100,
                    fontSize: '0.7rem', fontWeight: 600, background: sc.bg, color: sc.color,
                  }}>
                    {deal.stage || 'New Lead'}
                  </span>
                </td>
                <td style={{ padding: '0.625rem 0.5rem', fontSize: '0.813rem', fontWeight: 600, color: '#059669' }}>
                  {dealValue ? formatValue(dealValue) : '—'}
                </td>
                {userRole === 'admin' && (
                  <td style={{ padding: '0.625rem 0.5rem', fontSize: '0.75rem', color: '#8B5CF6', fontWeight: 500 }}>
                    {dealValue ? `${formatValue(commissionAmt)} (${commissionPct}%)` : '—'}
                  </td>
                )}
                <td style={{ padding: '0.625rem 0.5rem', fontSize: '0.75rem', color: '#6B7280' }}>
                  {deal.assigned_to_name || '—'}
                </td>
                <td style={{ padding: '0.625rem 0.5rem', fontSize: '0.7rem', color: '#9CA3AF' }}>
                  {formatDate(deal.created_at || deal.timestamp)}
                </td>
                <td style={{ padding: '0.625rem 0.5rem' }}>
                  <ChevronRight size={16} style={{ color: '#9CA3AF' }} />
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
};
